(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["installation-guide"] && !window.DesignMode) return;
  try {
    
  function playVideo(blockId, videoUrl) {
    const thumbnail = document.getElementById(`thumbnail-${blockId}`);
    const videoContainer = document.getElementById(`video-${blockId}`);
    const iframe = videoContainer.querySelector('iframe');
    
    iframe.src = videoUrl + '?autoplay=1';
    thumbnail.style.display = 'none';
    videoContainer.style.display = 'block';
  }

  } catch(e) { console.error(e); }
})();
})();
